import { gql, TypedDocumentNode } from '@apollo/client';
import { ProductInventoryItem } from '../models/ProductInventoryItem';

export const GET_PRODUCT_INVENTORY_ITEM_BY_ID_QUERY: TypedDocumentNode<{ productInventoryItem: ProductInventoryItem }, { id: number }> = gql`
  query GetProductInventoryItemById($id: Int!) {
    productInventoryItem: productInventoryItemById(id: $id) {
      id,
      productId,
      product {
        id
        name
      },
      packagingType,
      quantityOnHand,
      batchId,
      batch {
        id,
        lotNumber
      }
    }
  }
`;